<h2 mat-dialog-title>
    {{title}}
  </h2>
  
  <div mat-dialog-content>
    <p>{{message}}</p>
  </div>
  
  <div mat-dialog-actions>
    <button mat-raised-button cdkFocusInitial (click)="onDismiss()">No</button>
    <button mat-raised-button (click)="onConfirm()">Yes</button>
  </div>